var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XHmuqP.tif",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.36,
    height: 9.16,
    viewBox: "0 0 8.36 9.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M975.822,278.052a.57.57,0,0,1,.6-.4q3.158,0,6.316,0a.858.858,0,0,1,.225.029.507.507,0,0,1,.386.43.493.493,0,0,1-.219.507,1.4,1.4,0,0,1-.175.094q-3.512,0-7.023,0c-.1,0-.123-.018-.117-.117C975.829,278.414,975.822,278.232,975.822,278.052Z",
    transform: "translate(-975.818 -269.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1003.112,73.025a.408.408,0,0,1-.416-.464c.1-.623.219-1.244.327-1.867a.329.329,0,0,1,.1-.183l4.732-4.732c.12-.12.174-.119.3,0q.889.887,1.775,1.776c.128.129.128.177,0,.307l-4.71,4.713a.375.375,0,0,1-.207.116c-.618.107-1.235.217-1.852.326A.384.384,0,0,1,1003.112,73.025ZM1003.8,72l.843-.157a.251.251,0,0,0,.127-.088q1.971-1.972,3.944-3.942c.082-.082.073-.133-.005-.207q-.309-.3-.6-.605c-.077-.08-.127-.082-.207,0q-1.968,1.975-3.941,3.945a.288.288,0,0,0-.1.154q-.072.414-.148.827C1003.708,71.978,1003.715,72.012,1003.8,72Z",
    transform: "translate(-1001.664 -65.691)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.4d8be551d3fa5a53318af6c646c3f989.svg";
export { ForwardRef as ReactComponent };